import React from "react";
import {
  TabDelivery,
  TabPdtInfo,
  TabTariff
  // TabRelated
} from "./Tab/TabContent";
import { Translation } from "react-i18next";

let $ = window.$;
// function scrollTop(id) {
//   $(document).ready(function() {
//     $("html, body").scrollTop($("#accord_heading1").offset().top);
//   });
// }

const headerHeight = 60;

export default ({ info, matchingPdt, code, details }) => {
  return (
    <div className="pdt_accordion_wrap">
      <div className="accordion d-block d-md-none" id="pdtAccordion">
        <div className="card">
          <div className="card-header" id="accord_heading1">
            {/* 隱藏系列簡介 */}
            {/* {details.collection.code !== "C287" ? (
              <button
                className="accordionHead_btn collapsed"
                type="button"
                data-toggle="collapse"
                data-target="#accord_collapse1"
                aria-expanded="true"
                aria-controls="accord_collapse1"
                onClick={() => {
                  $(document).ready(function() {
                    $("html, body").scrollTop(
                      $("#accord_heading1").offset().top - 100
                    );
                  });
                }}
              >
                <Translation>
                  {t => <>{t(`tabListIndex.series`)}</>}
                </Translation>
                <span className="stroke" />
                <span className="stroke strokeV" />
              </button>
            ) : null} */}
          </div>
          {/* {details.collection.code !== "C287" ? (
            <div
              id="accord_collapse1"
              className="collapse"
              aria-labelledby="accord_heading1"
              data-parent="#pdtAccordion"
            >
              <div className="card-body tabContent noPadding">
                <TabCollectionIntro />
              </div>
            </div>
          ) : null} */}
        </div>
        {/* 產品資訊 */}
        <div className="card">
          <div className="card-header" id="accord_heading2">
            <button
              style={{ color: "#000" }}
              className="accordionHead_btn"
              type="button"
              data-toggle="collapse"
              data-target="#accord_collapse2"
              aria-expanded="true"
              aria-controls="accord_collapse2"
              onClick={() => {
                $("html, body").scrollTop(
                  $("#accord_heading1").offset().top - headerHeight
                );
              }}
            >
              <Translation>
                {t => <>{t(`tabListIndex.productDetails`)}</>}
              </Translation>
              <span className="stroke" />
              <span className="stroke strokeV" />
            </button>
          </div>
          <div
            id="accord_collapse2"
            className="collapse show"
            aria-labelledby="accord_heading2"
            data-parent="#pdtAccordion"
          >
            <div className="card-body tabContent">
              <p className="subtitle d-none d-md-block">
                <Translation>
                  {t => <>{t(`tabListIndex.productDetails`)}</>}
                </Translation>
              </p>
              {(info !== undefined && <TabPdtInfo info={info} />) || null}
            </div>
          </div>
        </div>
        {/* 配送及退貨 */}
        <div className="card">
          <div className="card-header" id="accord_heading3">
            <button
              style={{ color: "#000" }}
              className="accordionHead_btn collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#accord_collapse3"
              aria-expanded="false"
              aria-controls="accord_collapse3"
              onClick={() => {
                $("html, body").scrollTop(
                  $("#accord_heading1").offset().top -
                    headerHeight +
                    $("#accord_heading2").height()
                );
              }}
            >
              <Translation>
                {t => <>{t(`tabListIndex.shipping&Return`)}</>}
              </Translation>
              <span className="stroke" />
              <span className="stroke strokeV" />
            </button>
          </div>
          <div
            id="accord_collapse3"
            className="collapse"
            aria-labelledby="accord_heading3"
            data-parent="#pdtAccordion"
          >
            <div className="card-body tabContent">
              <p className="subtitle d-none d-md-block">
                {" "}
                <Translation>
                  {t => <>{t(`tabListIndex.shipping&Return`)}</>}
                </Translation>
              </p>

              <TabDelivery />
            </div>
          </div>
        </div>
        {/* 關稅 */}
        <div className="card">
          <div className="card-header" id="accord_heading4">
            <button
              style={{ color: "#000" }}
              className="accordionHead_btn collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#accord_collapse4"
              aria-expanded="false"
              aria-controls="accord_collapse4"
              onClick={() => {
                $("html, body").scrollTop(
                  $("#accord_heading1").offset().top -
                    headerHeight +
                    $("#accord_heading2").height() * 2
                );
              }}
            >
              <Translation>
                {t => <>{t(`tabListIndex.duties&Taxes`)}</>}
              </Translation>
              <span className="stroke" />
              <span className="stroke strokeV" />
            </button>
          </div>
          <div
            id="accord_collapse4"
            className="collapse"
            aria-labelledby="accord_heading4"
            data-parent="#pdtAccordion"
          >
            <div className="card-body tabContent">
              <p className="subtitle d-none d-md-block">
                <Translation>
                  {t => <>{t(`tabListIndex.duties&Taxes`)}</>}
                </Translation>
              </p>

              <TabTariff />
            </div>
          </div>
        </div>
        {/* <div className="card">
          <div className="card-header" id="accord_heading5">
            <button
              className="accordionHead_btn collapsed"
              type="button"
              data-toggle="collapse"
              data-target="#accord_collapse5"
              aria-expanded="false"
              aria-controls="accord_collapse5"
            >
              配搭頸鏈
              <span className="stroke" />
              <span className="stroke strokeV" />
            </button>
          </div>

          <div
            id="accord_collapse5"
            className="collapse"
            aria-labelledby="accord_heading5"
            data-parent="#pdtAccordion"
          >
            <div className="card-body tabContent">
              {(matchingPdt !== undefined && (
                <TabRelated matchingPdt={matchingPdt} />
              )) ||
                null}
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};
